export default "__VITE_ASSET__c988c408__"